var SubscriptionsUI;

SubscriptionsUI = (function() {
  var DOI_DISMISS_LIFE_IN_SECONDS, TEN_YEARS_IN_SECONDS, USER_AGENTS, _is_sub_str, appName, constructionTime, currentDivision, isSubForced, loadCompleteTime, loadStartTime;

  TEN_YEARS_IN_SECONDS = 60 * 60 * 24 * 365 * 10;

  DOI_DISMISS_LIFE_IN_SECONDS = 60 * 60;

  appName = null;

  currentDivision = 'chicago';

  isSubForced = false;

  constructionTime = 0;

  loadStartTime = 0;

  loadCompleteTime = 0;

  USER_AGENTS = ['googlebot', 'bingbot', 'ask jeeves', 'yahoo! slurp', 'seoagent', 'AdsBot-Google', 'AdsBot-Google-Mobile', 'psbot', 'gosospider', 'sogou', 'google web preview', 'google wireless transcoder', 'mediapartners-google', 'baidu', 'gigabot', 'googlebot-image', 'libwww-perl', 'lwp-trivial', 'msnbot', 'siteuptime', 'slurp', 'teoma', 'uptakebot', 'voyager', 'wordpress', 'yahooseeker', 'zibb', 'zyborg', 'wget', 'curl'];

  SubscriptionsUI.increment_visited_cookie = function() {
    var subscription_last_visited, visited;
    visited = parseInt(Cookie.get("subscription_visited"));
    if (isNaN(visited)) {
      visited = 1;
    } else {
      ++visited;
    }
    subscription_last_visited = (new Date()).getTime();
    Cookie.set("subscription_visited", visited, TEN_YEARS_IN_SECONDS);
    return Cookie.set("subscription_last_visited", subscription_last_visited, TEN_YEARS_IN_SECONDS);
  };

  function SubscriptionsUI() {
    var now, ref, ref1;
    now = new Date();
    constructionTime = now.getTime();
    this.version = '2.7.2';
    if ((typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.division) != null ? ref.id : void 0 : void 0) != null) {
      currentDivision = Groupon.division.id;
    } else if (Cookie.get('division') != null) {
      currentDivision = Cookie.get('division');
    }
    appName = this._get_app_name();
    now = new Date();
    if (typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null) {
      if ((ref1 = OptimizeSuite.TrackingHub) != null) {
        if (typeof ref1.add === "function") {
          ref1.add("subscriptionUIdelegated", {
            goalType: "subscription",
            _useSDS: window._useSDS,
            totalLatency: now.getTime() - constructionTime
          });
        }
      }
    }
    isSubForced = window.location.href.indexOf('subs_force=') > -1;
    if (isSubForced && ((typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub : void 0) != null)) {
      OptimizeSuite.TrackingHub.add("subscriptionUIForced", {
        goalType: "subscription"
      });
    }
    if (!(window._useSDS || this._should_not_show_subsUI())) {
      this._show_subscribe_drawer();
    }
  }

  SubscriptionsUI.prototype._should_show_doi = function() {
    return (appName !== 'user_sessions' && appName !== 'itier/subscription_center' && appName !== 'sub_center') && !Cookie.get("subscription_doi_dismissed") && (Cookie.get("optin") || Cookie.get("optin_reminder"));
  };

  SubscriptionsUI.prototype._show_subscribe_drawer = function() {
    var divisionDropdown;
    if (!Cookie.get("close_subscribe_drawer")) {
      divisionDropdown = $('#subscribe-division');
      if (divisionDropdown.attr('data-options_decoded') === "false") {
        divisionDropdown.attr({
          'data-options_decoded': "true"
        });
        $("#subscribe-division > option").each(function() {
          var decodedName;
          decodedName = $(this).text().split("").reverse().join("");
          return $(this).text(decodedName);
        });
      }
      return $('#subscribe-drawer').show();
    }
  };

  SubscriptionsUI.prototype._user_has_sub_cookie = function() {
    var c, cookies, i, legacy_international_cookie, len;
    legacy_international_cookie = (typeof I18n !== "undefined" && I18n !== null ? I18n.country.toLowerCase() : void 0) + "_nl_subscribed";
    cookies = ["subscriber_email", "scid", "l", "user_id", "c", "snickerdoodle", "macaroon", legacy_international_cookie];
    for (i = 0, len = cookies.length; i < len; i++) {
      c = cookies[i];
      if (Cookie.get(c)) {
        return true;
      }
    }
    return false;
  };

  SubscriptionsUI.prototype._should_not_show_subsUI = function() {
    if (isSubForced) {
      return false;
    } else if (this._user_has_sub_cookie() || this._is_bot() || this._skip_subscription_ui() || this._is_email_click_traffic()) {
      return true;
    } else if (Cookie.get("hide_sub_modal") && this._should_hide_subscribe_drawer()) {
      return true;
    } else if (appName === 'user_sessions') {
      return true;
    } else {
      return false;
    }
  };

  SubscriptionsUI.prototype._should_hide_subscribe_drawer = function() {
    var no_drawer;
    no_drawer = Cookie.get("close_subscribe_drawer") || Cookie.get("hide_sub_banner");
    if (no_drawer) {
      return true;
    }
    if ((typeof subscriptionsUI_hideSubscribeDrawer !== "undefined" && subscriptionsUI_hideSubscribeDrawer !== null) && subscriptionsUI_hideSubscribeDrawer) {
      if (appName === 'pull' || appName === 'gsm-ita') {
        return false;
      } else {
        return true;
      }
    }
  };

  SubscriptionsUI.prototype._is_email_click_traffic = function() {
    var utm_medium;
    utm_medium = new RegExp('[\\?&]utm_medium=([^&#]*)').exec(window.location.href);
    if (((utm_medium != null) && (utm_medium[1] != null) && utm_medium[1].toLowerCase() === 'email') || (Cookie.get('_tpmed') === 'email')) {
      return true;
    } else {
      return false;
    }
  };

  SubscriptionsUI.prototype._skip_subscription_ui = function() {
    if (new RegExp('[\\?&]z=skip').test(window.location.href)) {
      return true;
    }
  };

  _is_sub_str = function(string, subStr) {
    return string.toUpperCase().indexOf(subStr.toUpperCase()) > -1;
  };

  SubscriptionsUI.prototype._is_bot = function() {
    var i, len, userAgent, userAgentHeader;
    userAgentHeader = navigator.userAgent;
    if (userAgentHeader) {
      for (i = 0, len = USER_AGENTS.length; i < len; i++) {
        userAgent = USER_AGENTS[i];
        if (_is_sub_str(userAgentHeader, userAgent)) {
          return true;
        }
      }
    }
    return false;
  };

  SubscriptionsUI.prototype._get_page_info = function() {
    var page_info, ref, ref1;
    page_info = {};
    if (($('head').attr('data-app') != null) && $('head').attr('data-app').length > 0) {
      page_info.app = encodeURIComponent($('head').attr('data-app'));
    } else if (((typeof Optimize !== "undefined" && Optimize !== null ? (ref = Optimize.suiteData) != null ? ref.app : void 0 : void 0) != null) && (typeof Optimize !== "undefined" && Optimize !== null ? (ref1 = Optimize.suiteData) != null ? ref1.app.length : void 0 : void 0) > 0) {
      page_info.app = encodeURIComponent(Optimize.suiteData.app);
    }
    return page_info;
  };

  SubscriptionsUI.prototype._get_app_name = function() {
    var tmpAppName;
    tmpAppName = this._get_page_info().app;
    return appName = tmpAppName != null ? tmpAppName.toLowerCase() : null;
  };

  SubscriptionsUI.prototype._dismiss_subscribe_modal = function(container) {
    container.hide();
    return container.hideSpotlight && container.hideSpotlight();
  };

  SubscriptionsUI.prototype._get_doi_modal_and_show = function(overlayColor) {
    var jqxhr, now, url;
    url = '/app/subscriptions/doi';
    now = new Date();
    loadStartTime = now.getTime();
    return jqxhr = $.get(url, function(data) {
      var $container;
      now = new Date();
      loadCompleteTime = now.getTime();
      $container = $('<div id="subscribe_doi_modal_container" />');
      $container.css({
        "display": "none",
        "position": "fixed",
        "z-index": "9999"
      });
      $container.html(data);
      $(document.body).append($container);
      if ($('#no_doi').length > 0) {
        return;
      }
      return setTimeout((function() {
        var dlg_height, dlg_width, left, top;
        dlg_width = $container.width();
        dlg_height = $container.height();
        left = ($(window).width() - dlg_width) / 2;
        top = ($(window).height() - dlg_height) / 2;
        overlayColor = overlayColor != null ? overlayColor : "#eee";
        $container.css({
          top: top,
          left: left
        });
        $container.show();
        $container.spotlight({
          opacity: 0.7,
          color: overlayColor,
          exitEvent: "none"
        });
        now = new Date();
        if ((typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub : void 0) != null) {
          OptimizeSuite.TrackingHub.add("subscriptionDOIDialogShown", {
            goalType: "subscription",
            uiType: "modal-dialog",
            loadingLatency: loadCompleteTime - loadStartTime,
            totalLatency: now.getTime() - constructionTime
          });
        }
        return $('#doi_dlg').on("dismiss", function() {
          SubscriptionsUI._dismiss_subscribe_modal($container);
          Cookie.set("subscription_doi_dismissed", true, DOI_DISMISS_LIFE_IN_SECONDS);
          if ((typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub : void 0) != null) {
            return OptimizeSuite.TrackingHub.add("subscriptionDOIDialogHidden", {
              goalType: "subscription",
              uiType: "modal-dialog"
            });
          }
        });
      }), 500);
    });
  };

  return SubscriptionsUI;

})();

window.SubscriptionsUI = new SubscriptionsUI();

SubscriptionsUI.increment_visited_cookie();

if (window.SubscriptionsUI._should_show_doi()) {
  window.SubscriptionsUI._get_doi_modal_and_show('#333');
  return;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvc3JhamVuZHJhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MjIzOTY1NDE2MTAtNDU4ODIvcHJvZHVjdGlvbi0yMDE4LjAzLjI5XzE5LjU2L3N1YnNjcmlwdGlvbl9mbG93L2NvcmUvZnJvbnRlbmQvc3Vic2NyaXB0aW9uc191aS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9zcmFqZW5kcmFuL25hcGlzdHJhbm8vYnVpbGQvMTUyMjM5NjU0MTYxMC00NTg4Mi9wcm9kdWN0aW9uLTIwMTguMDMuMjlfMTkuNTYvc3Vic2NyaXB0aW9uX2Zsb3cvY29yZS9mcm9udGVuZC9zdWJzY3JpcHRpb25zX3VpLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFNO0FBQ0osTUFBQTs7RUFBQSxvQkFBQSxHQUF3QixFQUFBLEdBQUcsRUFBSCxHQUFNLEVBQU4sR0FBUyxHQUFULEdBQWE7O0VBQ3JDLDJCQUFBLEdBQStCLEVBQUEsR0FBRzs7RUFDbEMsT0FBQSxHQUFVOztFQUNWLGVBQUEsR0FBa0I7O0VBQ2xCLFdBQUEsR0FBYzs7RUFDZCxnQkFBQSxHQUFtQjs7RUFDbkIsYUFBQSxHQUFnQjs7RUFDaEIsZ0JBQUEsR0FBbUI7O0VBRW5CLFdBQUEsR0FBYyxDQUFDLFdBQUQsRUFBYyxTQUFkLEVBQXlCLFlBQXpCLEVBQXVDLGNBQXZDLEVBQXVELFVBQXZELEVBQW1FLGVBQW5FLEVBQW9GLHNCQUFwRixFQUE0RyxPQUE1RyxFQUFxSCxZQUFySCxFQUFtSSxPQUFuSSxFQUE0SSxvQkFBNUksRUFBa0ssNEJBQWxLLEVBQWdNLHNCQUFoTSxFQUF3TixPQUF4TixFQUFpTyxTQUFqTyxFQUE0TyxpQkFBNU8sRUFBK1AsYUFBL1AsRUFBOFEsYUFBOVEsRUFBNlIsUUFBN1IsRUFBdVMsWUFBdlMsRUFBcVQsT0FBclQsRUFBOFQsT0FBOVQsRUFBdVUsV0FBdlUsRUFBb1YsU0FBcFYsRUFBK1YsV0FBL1YsRUFBNFcsYUFBNVcsRUFBMlgsTUFBM1gsRUFBbVksUUFBblksRUFBNlksTUFBN1ksRUFBcVosTUFBclo7O0VBRWQsZUFBQyxDQUFBLHdCQUFELEdBQTBCLFNBQUE7QUFDeEIsUUFBQTtJQUFBLE9BQUEsR0FBVSxRQUFBLENBQVMsTUFBTSxDQUFDLEdBQVAsQ0FBVyxzQkFBWCxDQUFUO0lBQ1YsSUFBRyxLQUFBLENBQU0sT0FBTixDQUFIO01BQXVCLE9BQUEsR0FBVSxFQUFqQztLQUFBLE1BQUE7TUFBd0MsRUFBRSxRQUExQzs7SUFDQSx5QkFBQSxHQUE0QixDQUFLLElBQUEsSUFBQSxDQUFBLENBQUwsQ0FBWSxDQUFDLE9BQWIsQ0FBQTtJQUM1QixNQUFNLENBQUMsR0FBUCxDQUFXLHNCQUFYLEVBQW1DLE9BQW5DLEVBQTRDLG9CQUE1QztXQUNBLE1BQU0sQ0FBQyxHQUFQLENBQVcsMkJBQVgsRUFBd0MseUJBQXhDLEVBQW1FLG9CQUFuRTtFQUx3Qjs7RUFPYix5QkFBQTtBQUVYLFFBQUE7SUFBQSxHQUFBLEdBQVUsSUFBQSxJQUFBLENBQUE7SUFDVixnQkFBQSxHQUFtQixHQUFHLENBQUMsT0FBSixDQUFBO0lBR25CLElBQUMsQ0FBQSxPQUFELEdBQVc7SUFHWCxJQUFHLDBIQUFIO01BQ0UsZUFBQSxHQUFrQixPQUFPLENBQUMsUUFBUSxDQUFDLEdBRHJDO0tBQUEsTUFFSyxJQUFHLDhCQUFIO01BQ0gsZUFBQSxHQUFrQixNQUFNLENBQUMsR0FBUCxDQUFXLFVBQVgsRUFEZjs7SUFHTCxPQUFBLEdBQVUsSUFBQyxDQUFBLGFBQUQsQ0FBQTtJQUVWLEdBQUEsR0FBVSxJQUFBLElBQUEsQ0FBQTs7OztjQUNnQixDQUFFLElBQUssMkJBQy9CO1lBQUEsUUFBQSxFQUFVLGNBQVY7WUFDQSxPQUFBLEVBQVMsTUFBTSxDQUFDLE9BRGhCO1lBRUEsWUFBQSxFQUFjLEdBQUcsQ0FBQyxPQUFKLENBQUEsQ0FBQSxHQUFnQixnQkFGOUI7Ozs7O0lBSUYsV0FBQSxHQUFjLE1BQU0sQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLE9BQXJCLENBQTZCLGFBQTdCLENBQUEsR0FBOEMsQ0FBQztJQUM3RCxJQUFHLFdBQUEsSUFBZ0IsK0dBQW5CO01BQ0UsYUFBYSxDQUFDLFdBQVcsQ0FBQyxHQUExQixDQUE4QixzQkFBOUIsRUFBc0Q7UUFBQSxRQUFBLEVBQVUsY0FBVjtPQUF0RCxFQURGOztJQUdBLElBQUEsQ0FBaUMsQ0FBQyxNQUFNLENBQUMsT0FBUCxJQUFrQixJQUFDLENBQUEsdUJBQUQsQ0FBQSxDQUFuQixDQUFqQztNQUFBLElBQUMsQ0FBQSxzQkFBRCxDQUFBLEVBQUE7O0VBMUJXOzs0QkE0QmIsZ0JBQUEsR0FBa0IsU0FBQTtXQUNoQixDQUFBLE9BQUEsS0FBZ0IsZUFBaEIsSUFBQSxPQUFBLEtBQWlDLDJCQUFqQyxJQUFBLE9BQUEsS0FBOEQsWUFBOUQsQ0FBQSxJQUNBLENBQUMsTUFBTSxDQUFDLEdBQVAsQ0FBVyw0QkFBWCxDQURELElBRUEsQ0FBQyxNQUFNLENBQUMsR0FBUCxDQUFXLE9BQVgsQ0FBQSxJQUF1QixNQUFNLENBQUMsR0FBUCxDQUFXLGdCQUFYLENBQXhCO0VBSGdCOzs0QkFLbEIsc0JBQUEsR0FBd0IsU0FBQTtBQUN0QixRQUFBO0lBQUEsSUFBRyxDQUFDLE1BQU0sQ0FBQyxHQUFQLENBQVcsd0JBQVgsQ0FBSjtNQUNFLGdCQUFBLEdBQW1CLENBQUEsQ0FBRSxxQkFBRjtNQUNuQixJQUFHLGdCQUFnQixDQUFDLElBQWpCLENBQXNCLHNCQUF0QixDQUFBLEtBQWlELE9BQXBEO1FBQ0UsZ0JBQWdCLENBQUMsSUFBakIsQ0FBc0I7VUFBQyxzQkFBQSxFQUF3QixNQUF6QjtTQUF0QjtRQUNBLENBQUEsQ0FBRSw4QkFBRixDQUFpQyxDQUFDLElBQWxDLENBQXVDLFNBQUE7QUFDckMsY0FBQTtVQUFBLFdBQUEsR0FBYyxDQUFBLENBQUUsSUFBRixDQUFPLENBQUMsSUFBUixDQUFBLENBQWMsQ0FBQyxLQUFmLENBQXFCLEVBQXJCLENBQXdCLENBQUMsT0FBekIsQ0FBQSxDQUFrQyxDQUFDLElBQW5DLENBQXdDLEVBQXhDO2lCQUNkLENBQUEsQ0FBRSxJQUFGLENBQU8sQ0FBQyxJQUFSLENBQWEsV0FBYjtRQUZxQyxDQUF2QyxFQUZGOzthQUtBLENBQUEsQ0FBRSxtQkFBRixDQUFzQixDQUFDLElBQXZCLENBQUEsRUFQRjs7RUFEc0I7OzRCQVV4QixvQkFBQSxHQUFzQixTQUFBO0FBQ3BCLFFBQUE7SUFBQSwyQkFBQSxtREFBOEIsSUFBSSxDQUFFLE9BQU8sQ0FBQyxXQUFkLENBQUEsV0FBQSxHQUE4QjtJQUM1RCxPQUFBLEdBQVUsQ0FBQyxrQkFBRCxFQUFxQixNQUFyQixFQUE2QixHQUE3QixFQUFrQyxTQUFsQyxFQUE2QyxHQUE3QyxFQUFrRCxlQUFsRCxFQUFtRSxVQUFuRSxFQUErRSwyQkFBL0U7QUFDVixTQUFBLHlDQUFBOztNQUNFLElBQUcsTUFBTSxDQUFDLEdBQVAsQ0FBVyxDQUFYLENBQUg7QUFBcUIsZUFBTyxLQUE1Qjs7QUFERjtBQUVBLFdBQU87RUFMYTs7NEJBT3RCLHVCQUFBLEdBQXlCLFNBQUE7SUFDdkIsSUFBRyxXQUFIO0FBQ0UsYUFBTyxNQURUO0tBQUEsTUFFSyxJQUFHLElBQUMsQ0FBQSxvQkFBRCxDQUFBLENBQUEsSUFBMkIsSUFBQyxDQUFBLE9BQUQsQ0FBQSxDQUEzQixJQUF5QyxJQUFDLENBQUEscUJBQUQsQ0FBQSxDQUF6QyxJQUFxRSxJQUFDLENBQUEsdUJBQUQsQ0FBQSxDQUF4RTtBQUNILGFBQU8sS0FESjtLQUFBLE1BRUEsSUFBRyxNQUFNLENBQUMsR0FBUCxDQUFXLGdCQUFYLENBQUEsSUFBaUMsSUFBQyxDQUFBLDZCQUFELENBQUEsQ0FBcEM7QUFDSCxhQUFPLEtBREo7S0FBQSxNQUVBLElBQUcsT0FBQSxLQUFXLGVBQWQ7QUFDSCxhQUFPLEtBREo7S0FBQSxNQUFBO0FBR0gsYUFBTyxNQUhKOztFQVBrQjs7NEJBWXpCLDZCQUFBLEdBQStCLFNBQUE7QUFDN0IsUUFBQTtJQUFBLFNBQUEsR0FBWSxNQUFNLENBQUMsR0FBUCxDQUFXLHdCQUFYLENBQUEsSUFBd0MsTUFBTSxDQUFDLEdBQVAsQ0FBVyxpQkFBWDtJQUNwRCxJQUFHLFNBQUg7QUFDRSxhQUFPLEtBRFQ7O0lBRUEsSUFBRyw0R0FBQSxJQUF5QyxtQ0FBNUM7TUFHRSxJQUFHLE9BQUEsS0FBWSxNQUFaLElBQUEsT0FBQSxLQUFtQixTQUF0QjtBQUNFLGVBQU8sTUFEVDtPQUFBLE1BQUE7QUFHRSxlQUFPLEtBSFQ7T0FIRjs7RUFKNkI7OzRCQVkvQix1QkFBQSxHQUF5QixTQUFBO0FBQ3ZCLFFBQUE7SUFBQSxVQUFBLEdBQWlCLElBQUEsTUFBQSxDQUFPLDJCQUFQLENBQW1DLENBQUMsSUFBcEMsQ0FBeUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxJQUF6RDtJQUNqQixJQUFHLENBQUMsb0JBQUEsSUFBZ0IsdUJBQWhCLElBQW1DLFVBQVcsQ0FBQSxDQUFBLENBQUUsQ0FBQyxXQUFkLENBQUEsQ0FBQSxLQUErQixPQUFuRSxDQUFBLElBQStFLENBQUMsTUFBTSxDQUFDLEdBQVAsQ0FBVyxRQUFYLENBQUEsS0FBd0IsT0FBekIsQ0FBbEY7QUFFRSxhQUFPLEtBRlQ7S0FBQSxNQUFBO0FBSUUsYUFBTyxNQUpUOztFQUZ1Qjs7NEJBUXpCLHFCQUFBLEdBQXdCLFNBQUE7SUFFdEIsSUFBTyxJQUFBLE1BQUEsQ0FBTyxjQUFQLENBQXNCLENBQUMsSUFBdkIsQ0FBNEIsTUFBTSxDQUFDLFFBQVEsQ0FBQyxJQUE1QyxDQUFQO0FBQ0UsYUFBTyxLQURUOztFQUZzQjs7RUFLeEIsV0FBQSxHQUFjLFNBQUMsTUFBRCxFQUFTLE1BQVQ7V0FDWixNQUFNLENBQUMsV0FBUCxDQUFBLENBQW9CLENBQUMsT0FBckIsQ0FBNkIsTUFBTSxDQUFDLFdBQVAsQ0FBQSxDQUE3QixDQUFBLEdBQXFELENBQUM7RUFEMUM7OzRCQUdkLE9BQUEsR0FBUyxTQUFBO0FBQ1AsUUFBQTtJQUFBLGVBQUEsR0FBa0IsU0FBUyxDQUFDO0lBQzVCLElBQUcsZUFBSDtBQUNFLFdBQUEsNkNBQUE7O1FBQ0UsSUFBZSxXQUFBLENBQVksZUFBWixFQUE2QixTQUE3QixDQUFmO0FBQUEsaUJBQU8sS0FBUDs7QUFERixPQURGOztBQUdBLFdBQU87RUFMQTs7NEJBT1QsY0FBQSxHQUFnQixTQUFBO0FBQ2QsUUFBQTtJQUFBLFNBQUEsR0FBWTtJQUNaLElBQUcsb0NBQUEsSUFBZ0MsQ0FBQSxDQUFFLE1BQUYsQ0FBUyxDQUFDLElBQVYsQ0FBZSxVQUFmLENBQTBCLENBQUMsTUFBM0IsR0FBb0MsQ0FBdkU7TUFDRSxTQUFTLENBQUMsR0FBVixHQUFnQixrQkFBQSxDQUFtQixDQUFBLENBQUUsTUFBRixDQUFTLENBQUMsSUFBVixDQUFlLFVBQWYsQ0FBbkIsRUFEbEI7S0FBQSxNQUVLLElBQUcsaUlBQUEsc0dBQWlELENBQUUsR0FBRyxDQUFDLHlCQUF6QixHQUFrQyxDQUFuRTtNQUNILFNBQVMsQ0FBQyxHQUFWLEdBQWdCLGtCQUFBLENBQW1CLFFBQVEsQ0FBQyxTQUFTLENBQUMsR0FBdEMsRUFEYjs7QUFFTCxXQUFPO0VBTk87OzRCQVFoQixhQUFBLEdBQWUsU0FBQTtBQUNiLFFBQUE7SUFBQSxVQUFBLEdBQWEsSUFBQyxDQUFBLGNBQUQsQ0FBQSxDQUFpQixDQUFDO1dBQy9CLE9BQUEsR0FBYSxrQkFBSCxHQUFvQixVQUFVLENBQUMsV0FBWCxDQUFBLENBQXBCLEdBQWtEO0VBRi9DOzs0QkFJZix3QkFBQSxHQUEwQixTQUFDLFNBQUQ7SUFDeEIsU0FBUyxDQUFDLElBQVYsQ0FBQTtXQUNBLFNBQVMsQ0FBQyxhQUFWLElBQTJCLFNBQVMsQ0FBQyxhQUFWLENBQUE7RUFGSDs7NEJBSTFCLHVCQUFBLEdBQXlCLFNBQUMsWUFBRDtBQUN2QixRQUFBO0lBQUEsR0FBQSxHQUFNO0lBQ04sR0FBQSxHQUFVLElBQUEsSUFBQSxDQUFBO0lBQ1YsYUFBQSxHQUFnQixHQUFHLENBQUMsT0FBSixDQUFBO1dBRWhCLEtBQUEsR0FBUSxDQUFDLENBQUMsR0FBRixDQUFNLEdBQU4sRUFBVyxTQUFDLElBQUQ7QUFDakIsVUFBQTtNQUFBLEdBQUEsR0FBVSxJQUFBLElBQUEsQ0FBQTtNQUNWLGdCQUFBLEdBQW1CLEdBQUcsQ0FBQyxPQUFKLENBQUE7TUFFbkIsVUFBQSxHQUFhLENBQUEsQ0FBRSw0Q0FBRjtNQUNiLFVBQVUsQ0FBQyxHQUFYLENBQ0U7UUFBQSxTQUFBLEVBQVcsTUFBWDtRQUNBLFVBQUEsRUFBWSxPQURaO1FBRUEsU0FBQSxFQUFXLE1BRlg7T0FERjtNQUlBLFVBQVUsQ0FBQyxJQUFYLENBQWdCLElBQWhCO01BQ0EsQ0FBQSxDQUFFLFFBQVEsQ0FBQyxJQUFYLENBQWdCLENBQUMsTUFBakIsQ0FBd0IsVUFBeEI7TUFFQSxJQUFHLENBQUEsQ0FBRSxTQUFGLENBQVksQ0FBQyxNQUFiLEdBQXNCLENBQXpCO0FBQ0UsZUFERjs7YUFJQSxVQUFBLENBQVcsQ0FBQyxTQUFBO0FBQ1YsWUFBQTtRQUFBLFNBQUEsR0FBWSxVQUFVLENBQUMsS0FBWCxDQUFBO1FBQ1osVUFBQSxHQUFhLFVBQVUsQ0FBQyxNQUFYLENBQUE7UUFDYixJQUFBLEdBQU8sQ0FBQyxDQUFBLENBQUUsTUFBRixDQUFTLENBQUMsS0FBVixDQUFBLENBQUEsR0FBb0IsU0FBckIsQ0FBQSxHQUFrQztRQUN6QyxHQUFBLEdBQU0sQ0FBQyxDQUFBLENBQUUsTUFBRixDQUFTLENBQUMsTUFBVixDQUFBLENBQUEsR0FBcUIsVUFBdEIsQ0FBQSxHQUFvQztRQUMxQyxZQUFBLEdBQWtCLG9CQUFILEdBQXNCLFlBQXRCLEdBQXdDO1FBQ3ZELFVBQVUsQ0FBQyxHQUFYLENBQ0U7VUFBQSxHQUFBLEVBQUssR0FBTDtVQUNBLElBQUEsRUFBTSxJQUROO1NBREY7UUFJQSxVQUFVLENBQUMsSUFBWCxDQUFBO1FBQ0EsVUFBVSxDQUFDLFNBQVgsQ0FDRTtVQUFBLE9BQUEsRUFBUyxHQUFUO1VBQ0EsS0FBQSxFQUFPLFlBRFA7VUFFQSxTQUFBLEVBQVcsTUFGWDtTQURGO1FBS0EsR0FBQSxHQUFVLElBQUEsSUFBQSxDQUFBO1FBQ1YsSUFBRyw2R0FBSDtVQUNFLGFBQWEsQ0FBQyxXQUFXLENBQUMsR0FBMUIsQ0FBOEIsNEJBQTlCLEVBQ0U7WUFBQSxRQUFBLEVBQVUsY0FBVjtZQUNBLE1BQUEsRUFBUSxjQURSO1lBRUEsY0FBQSxFQUFnQixnQkFBQSxHQUFtQixhQUZuQztZQUdBLFlBQUEsRUFBYyxHQUFHLENBQUMsT0FBSixDQUFBLENBQUEsR0FBZ0IsZ0JBSDlCO1dBREYsRUFERjs7ZUFPQSxDQUFBLENBQUUsVUFBRixDQUFhLENBQUMsRUFBZCxDQUFpQixTQUFqQixFQUE0QixTQUFBO1VBQzFCLGVBQWUsQ0FBQyx3QkFBaEIsQ0FBeUMsVUFBekM7VUFDQSxNQUFNLENBQUMsR0FBUCxDQUFXLDRCQUFYLEVBQXlDLElBQXpDLEVBQStDLDJCQUEvQztVQUNBLElBQUcsNkdBQUg7bUJBQ0UsYUFBYSxDQUFDLFdBQVcsQ0FBQyxHQUExQixDQUE4Qiw2QkFBOUIsRUFDRTtjQUFBLFFBQUEsRUFBVSxjQUFWO2NBQ0EsTUFBQSxFQUFRLGNBRFI7YUFERixFQURGOztRQUgwQixDQUE1QjtNQXhCVSxDQUFELENBQVgsRUErQkcsR0EvQkg7SUFoQmlCLENBQVg7RUFMZTs7Ozs7O0FBdUQzQixNQUFNLENBQUMsZUFBUCxHQUE2QixJQUFBLGVBQUEsQ0FBQTs7QUFDN0IsZUFBZSxDQUFDLHdCQUFoQixDQUFBOztBQUdBLElBQUcsTUFBTSxDQUFDLGVBQWUsQ0FBQyxnQkFBdkIsQ0FBQSxDQUFIO0VBQ0UsTUFBTSxDQUFDLGVBQWUsQ0FBQyx1QkFBdkIsQ0FBK0MsTUFBL0M7QUFDQSxTQUZGIn0=
